export default __webpack_public_path__ + "static/media/sounds/clic_continuare.mp3";